<template>
  <div class="container" v-if="item">
    <h1 :class="{ textDanger: item.dead }">
      <span v-if="item.dead === true">💀 </span>{{ item.name }} <span v-if="item.dead === true" class="subheader"> - R.I.P.</span>
      <router-link class="btn btn-primary btn-sm pull-right" :to="`/characters/${item._id}/edit`" v-if="canEdit">
        Edit
      </router-link>
    </h1>
    <hr>
    <div class="row">
      <div v-if="item.image && item.image.url" class="col-lg-4 text-center d-print-none">
        <img class="img-fluid" :src="item.image.url">
      </div>
      <div class="col">
        <div class="row">
          <div class="col-6 col-md-3" v-if="item._user && item._user.name">
            <h5>Player</h5>
            <p>{{ item._user.name }}</p>
          </div>
        </div>

        <div v-if="item.description">
          <h5>Description</h5>
          <div v-html="$embers.markdown(item.description)"></div>
        </div>

        <div v-if="item.personality">
          <div v-if="item.personality.traits">
            <h5>Personality Traits</h5>
            <div v-html="$embers.markdown(item.personality.traits)"></div>
          </div>
          <div v-if="item.personality.ideals">
            <h5>Ideals</h5>
            <div v-html="$embers.markdown(item.personality.ideals)"></div>
          </div>
          <div v-if="item.personality.bonds">
            <h5>Bonds</h5>
            <div v-html="$embers.markdown(item.personality.bonds)"></div>
          </div>
          <div v-if="item.personality.flaws">
            <h5>Flaws</h5>
            <div v-html="$embers.markdown(item.personality.flaws)"></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "character-detail",
  props: ["item"],
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  }
};
</script>

<style scoped>
h2 {
  display: inline-block;
}

.btn {
  margin-right: 1em;
}
</style>
